import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../../../_common/carousel';
import CrossSellCollectionSlide from './cross-sell-collection-slide';

class CrossSellCollection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      responseMessage: undefined,
    };
  }

  renderSlides = () => {
    const { collection } = this.props;

    return collection.map(item => {
      const {
        collection_id: collectionId,
        product_id: productId,
        theme_id: themeId,
      } = item;

      const key = `collectionSlide_${collectionId}_${productId}_${themeId}`;

      return (
        <CrossSellCollectionSlide
          key={key}
          item={item}
          handleResponseMessage={this.handleResponseMessage}
        />
      );
    });
  };

  handleResponseMessage = message => {
    this.setState({ responseMessage: message });
  };

  render() {
    const { responseMessage } = this.state;
    const { id, slidesToShow } = this.props;
    const slickSettings = {
      // generic settings
      arrows: true,
      infinite: true,
      speed: 300,
      dots: true,

      // xl - wide desktops
      slidesToShow: slidesToShow || 3,
      slidesToScroll: slidesToShow || 3,

      responsive: [
        {
          // lg - desktops
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          // md - tablets
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
        {
          // sm - new phones
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
        {
          // xs - old phones
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
          },
        },
      ],
    };

    return (
      <div className="cross-sell-collection">
        <div className="mb-2">
          <span className="cross-sell-collection-header">
            You might also like
          </span>
        </div>
        <Carousel
          id={id}
          slickSettings={slickSettings}
          responseMessage={responseMessage}>
          {this.renderSlides()}
        </Carousel>
      </div>
    );
  }
}

CrossSellCollection.propTypes = {
  collection: PropTypes.arrayOf(
    PropTypes.shape({
      design_code: PropTypes.string,
      product_id: PropTypes.number,
      theme_id: PropTypes.number,
      thumbnails: PropTypes.arrayOf(PropTypes.string),
      title: PropTypes.string,
      unit_prices: PropTypes.arrayOf(
        PropTypes.shape({ from: PropTypes.number, price: PropTypes.number })
      ),
    })
  ).isRequired,
  id: PropTypes.string.isRequired,
  slidesToShow: PropTypes.number.isRequired,
};

export default CrossSellCollection;
